import { createAsyncThunk, createSlice,combineReducers } from "@reduxjs/toolkit";
import { BASE_URL } from "../config";
import { PatientsState } from "../interfaces/Patients";
import axios from "axios";


interface ParsedData {
  accessToken?: string;
}

interface ProfileState {
  loading: boolean;
  user: PatientsState | null; // Change here
  error: string | null;
  isLoggedIn: boolean;
  data: PatientsState[] | null;
}

const initialState: ProfileState = {
  loading: false,
  user: null,
  error: null,
  isLoggedIn: false,
  data: null,
};


export const ProfileDetails = createAsyncThunk(
  "profile/ProfileDetails",
  async (_, thunkAPI) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
        console.error("Response data is null.");
        return thunkAPI.rejectWithValue("Response data is null.");
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return thunkAPI.rejectWithValue("Access token not found in the response.");
      }
    
      const response = await fetch(`${BASE_URL}/api/v1/patients/profile`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      });

      if (!response.ok) {
        return thunkAPI.rejectWithValue(`HTTP error! Status: ${response.status}`);
       }

      const result = await response.json();
              
      return result.data.user;
    } catch (error: any) {
      console.error("Error fetching User Details:", error.message);
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);

export const UpdateProfile = createAsyncThunk(
  "profile/UpdateProfile",
  async (updatedProfileData: any, thunkAPI) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
        console.error("Response data is null.");
        return thunkAPI.rejectWithValue("Response data is null.");
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return thunkAPI.rejectWithValue("Access token not found in the response.");
      }

      const response = await fetch(`${BASE_URL}/api/v1/patients/profile`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: updatedProfileData,
      });

      if (!response.ok) {
        return thunkAPI.rejectWithValue(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      return result.data.user; // Update this based on the structure of your response
    } catch (error: any) {
      console.error("Error updating profile:", error.message);
      return thunkAPI.rejectWithValue(`Update failed: ${error.message}`);
    }
  }
);


const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ProfileDetails.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(ProfileDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // Check the correct path
      })
      .addCase(ProfileDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error creating payment intent:", action.payload); // Log the detailed error
      }).addCase(UpdateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UpdateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(UpdateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error updating profile:", action.payload);
      });;
      
  },
});

export const { resetState } = profileSlice.actions;
export default profileSlice.reducer;
